import axios from "axios";
export default function ArticlesInAllMagasin(){
    const UrlArticles= `${process.env.REACT_APP_PHP_APP_URL}/magasin/allarticlesinallmagasin`;
    const GatAllArticle=()=>{
        return (axios.get(UrlArticles));
    }
    return {
        GatAllArticle
    }
}